export const config: any = {
  brand: '3D摄影',
}
